var exports = {
  "kL": "x0a7806d5--92ce68--container",
  "$h": "x0a7806d5--92ce68--closed",
  "Qs": "x0a7806d5--92ce68--content",
  "R_": "x0a7806d5--92ce68--heading",
  "DD": "x0a7806d5--92ce68--title",
  "c5": "x0a7806d5--92ce68--arrow-wrapper",
};

module.exports = exports;
